module.exports = __webpack_public_path__ + "static/img/req_type.9e30b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intderface/req_type.png
// module id = mrDI
// module chunks = 0